import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Button from '@ui/Button';

function ToggleButton(props) {
  const {
    selected,
    label,
    value,
    color = 'primary',
    onToggle = null,
    disabled = false,
    ...rest
  } = props;
  const [selectedState, setSelectedState] = useState(selected);

  useEffect(() => {
    setSelectedState(selected);
  }, [selected]);

  const handleClick = () => {
    if (!disabled) {
      const status = !selectedState;
      setSelectedState(status);
      if (onToggle) {
        onToggle(status, value);
      }
    }
  };

  return (
    <Button
      type="button"
      variant="chip"
      color={color}
      selected={selectedState}
      onClick={handleClick}
      {...rest}>
      {label}
    </Button>
  );
}

export default ToggleButton;
